export var Cache;
(function (Cache) {
})(Cache || (Cache = {}));
//# sourceMappingURL=Cache.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/cache/core/types/Cache.js
// module id = 1481
// module chunks = 4